export const ROUTE_LOGIN = "/login"
export const ROUTE_SIGN_UP = "/signUp"
export const ROUTE_FORGOT_PASSWORD = "/forgotPassword"
export const ROUTE_JOIN_COMPANY = "/joinCompany"
export const ROUTE_NEW_COMPANY = "/newCompany"
export const ROUTE_EDIT_COMPANY = "/editCompany"
export const ROUTE_NEW_PROJECT = "/newProject"
export const ROUTE_EDIT_PROJECT = "/editProject"
export const ROUTE_MAP = "/map"